<template>
  <div class="fixed-area" ref="root">
    <div class="scroll-ref">
      <div class="scroll-position" ref="scrollPos1" style="background:blue"></div>
      <div class="scroll-position" ref="scrollPos2" style="background:green"></div>
      <div class="scroll-position" ref="scrollPos3" style="height:0;background:blue"></div>
    </div>
    <div :class="'fixed-wrapper '+fixedWrapperClass">
      <div class="sub-logo">
        <img src="../../assets/Main/SubSection/logo_sub.png">
      </div>
      <div :class="'section '+sectionClass" ref="scrollMobilePos1">
        <div class="container">
          <div class="title1-container">
            <SectionTitle title-img-name="meibo.png" ref="title1"/>
          </div>
          <div class="note1-container">
            <Note note-type="player" ref="note1"/>
          </div>
        </div>
      </div>
      <div :class="'section '+sectionClass">
        <div class="container">
          <div class="columns is-gapless">
            <div class="column" ref="scrollMobilePos2">
              <div class="section2-container">
                <div class="title2-container">
                  <SectionTitle title-img-name="boukensya.png" ref="title21"/>
                </div>
                <div class="note2-container">
                  <a href="https://twitter.com/toyKasket/lists/la-kasketia" target="_blank">
                    <Note note-type="artists" ref="note21"/>
                  </a>
                </div>
              </div>
            </div>
            <div class="column" ref="scrollMobilePos3">
              <div class="section2-container">
                <div class="title2-container">
                  <SectionTitle title-img-name="girudokanri.png" ref="title22"/>
                </div>
                <div class="note2-container">
                  <a href="https://twitter.com/toyKasket/lists/la-kasketia" target="_blank">
                    <Note note-type="direction" ref="note22"/>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div :class="spacerClass"></div>
  </div>
</template>

<script>
  import SectionTitle from "../Parts/SectionTitle.vue";
  import Note from "../Parts/Note.vue";
  import Button from "../Controlls/Button";

  export default {
    name: "FixArea",
    components: {
      Button,
      SectionTitle,
      Note
    },
    data() {
      return {
        fixedWrapperClass: "",
        sectionClass: "",
        spacerClass: "spacer"
      };
    },
    mounted: function () {
      var $ = require("jquery");
      const setupScrollTrigger = () => {
        const ScrollTrigger = require("scrolltrigger-classes");
        const trigger = new ScrollTrigger(
          {
            offset: {x: -50, y: 0},
            once: false,
            centerVertical: true
          },
          document.body,
          window
        );

        var scrollPos1;
        var scrollPos2;
        var scrollPos3;

        const onResize = () => {
          if (window.innerWidth > 768) {
            scrollPos1 = $(this.$refs.scrollPos1).offset().top;
            scrollPos2 = $(this.$refs.scrollPos2).offset().top;
            scrollPos3 = $(this.$refs.scrollPos3).offset().top;
          } else {
            scrollPos1 = $(this.$refs.scrollMobilePos1).offset().top;
            scrollPos2 = $(this.$refs.scrollMobilePos2).offset().top;
            scrollPos3 = $(this.$refs.scrollMobilePos3).offset().top;
          }
        };

        onResize();
        window.addEventListener("resize", () => {
          onResize();
        });

        var scrollSection = 0; // インデックス
        var lastScrollSection = 0;
        trigger.attach((scrollLeft, scrollTop, width, height) => {
          let scrollCenter = scrollTop + height / 2;
          let scrollBottom = scrollTop + height;

          if (scrollCenter < scrollPos1) {
            scrollSection = 0;
          } else if (scrollCenter > scrollPos1 && scrollCenter < scrollPos2) {
            scrollSection = 1;
          } else if (scrollCenter > scrollPos2 && scrollCenter < scrollPos3) {
            scrollSection = 2;
          } else if (scrollCenter > scrollPos3) {
            scrollSection = 3;
          }

          if (scrollSection != lastScrollSection) {
            // scrollSectionに入るときに1度だけ呼ばれる
            switch (scrollSection) {
              case 0:
                break;
              case 1:
                this.$refs.title1.showCallback();
                this.$refs.note1.showCallback();
                break;
              case 2:
                this.$refs.title21.showCallback();
                this.$refs.note21.showCallback();
                if (window.innerWidth > 768) {
                  this.$refs.title22.showCallback();
                  this.$refs.note22.showCallback();
                }
                break;
              case 3:
                if (window.innerWidth <= 768) {
                  this.$refs.title22.showCallback();
                  this.$refs.note22.showCallback();
                }
                break;
              default:
                break;
            }

            // lastScrollSectionを出るときに1度だけ呼ばれる
            switch (lastScrollSection) {
              case 0:
                break;
              case 1:
                this.$refs.title1.hideCallback();
                this.$refs.note1.hideCallback();
                break;
              case 2:
                this.$refs.title21.hideCallback();
                this.$refs.note21.hideCallback();
                if (window.innerWidth > 768) {
                  this.$refs.title22.hideCallback();
                  this.$refs.note22.hideCallback();
                }
                break;
              case 3:
                if (window.innerWidth <= 768) {
                  this.$refs.title22.hideCallback();
                  this.$refs.note22.hideCallback();
                }
                break;
              default:
                break;
            }
          }
          lastScrollSection = scrollSection;
        });
      };

      const callChildrensOnDisplayedRecursive = parent => {
        if (parent.$children) {
          parent.$children.forEach(child => {
            if (typeof child.onDisplayed == "function") {
              child.onDisplayed();
              callChildrensOnDisplayedRecursive(child);
            }
          });
        }
      };
      // display:noneが解除されていればonDisplay()を再帰的に実行
      const timerId = setInterval(() => {
        if (this.$refs.root.offsetParent != null) {
          callChildrensOnDisplayedRecursive(this);
          setupScrollTrigger();
          clearInterval(timerId);
        }
      }, 100);
    }
  };
</script>

<style lang="scss" scoped>
  .container {
    width: 100%;
  }

  .fixed-area {
    pointer-events: none;
  }

  .fixed-wrapper {
    position: sticky;
    top: 0;
    overflow: hidden;
    height: auto;
    width: 100vw;
    background-image: url("../../assets/Main/SubSection/bgloop.png");
    z-index: 0;
    animation: move-bg 10s infinite linear;
  }

  @keyframes move-bg {
    0% {
      background-position: 0 0;
    }

    100% {
      background-position: 375px 302px;
    }
  }

  // for mobile
  @media screen and (max-width: 768px) {
    .spacer {
      height: 0;
    }

    .sub-logo {
      display: none;
    }

    .fixed-wrapper {
      position: relative;
    }
    .section {
      padding-top: 0;
      position: relative;
    }

    .title1-container,
    .title2-container,
    .title3-container {
      position: relative;
      display: flex;
      justify-content: center;
      left: 0;
      padding-top: 5%;
      padding-left: 15%;
      padding-right: 15%;
      margin-bottom: -5%;
      width: 100%;
      z-index: 100;
    }

    .note1-container,
    .note2-container,
    .note3-container {
      position: relative;
      display: flex;
      justify-content: center;
      left: 0%;
      top: 0%;
      width: 100%;
    }
  }

  // for desktop
  @media screen and (min-width: 769px) {
    .spacer {
      // 2 * scroll-position height (+ fixed wrapper height)
      height: 100vh;
    }

    .sub-logo {
      position: absolute;
      width: 10vw;
      right: 2vw;
      bottom: 2vh;
    }

    .fixed-wrapper {
      height: 100vh;
    }
    .section {
      position: absolute;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 100vh;
    }

    .title1-container {
      position: absolute;
      left: 0;
      top: 0;
      width: 30%;
      z-index: 1;
    }

    .note1-container {
      position: relative;
      left: 28%;
      top: 20%;
      width: 76%;
      height: auto;
    }

    .column {
    }

    .section2-container {
      width: 100%;
    }

    .title2-container {
      position: relative;
      width: 40vh;
      z-index: 1;
    }

    .note2-container {
      position: relative;
      margin-top: -10%;
      margin-left: 20%;
      height: auto;
      width: 80%;
    }
  }

  .scroll-ref {
    position: absolute;
  }

  .scroll-position {
    position: relative;
    width: 6vw;
    height: 100vh;
    opacity: 0;
  }

  .visible {
    transition: 0.7s ease;
    opacity: 1;
    pointer-events: auto;
  }

  .invisible {
    transition: 0.7s ease;
    opacity: 0;
    pointer-events: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/Sections/FixArea.vue